//MongoDB Query Class
//Helper functions for constructing a MongoDB query object

var deepCopy = require('./util/deepCopy'),
	extend = require('util')._extend;

module.exports = MongoQuery;

function MongoQuery(json) {
	if (json) extend(this, json);
}

extend(MongoQuery.prototype, {
	constructor: MongoQuery

	//Add an $in or $all condition to the MongoDB query
  , addArraySearchCondition: function(query, fieldName, arrValues, matchAll) {
		if (!Array.isArray(arrValues)) {
			arrValues = [arrValues];
		}
		query[fieldName] = {};
		var inOrAll = (matchAll ? '$all': '$in');
		query[fieldName][inOrAll] = arrValues;
	}

  , clone: function clone() {
		var clone = new MongoQuery();
		for (var key in this) {
			clone[key] = deepCopy(this[key]);
		}
		return clone;
	}

	/**
	 * @param {string} fieldNamesAndDirections
	 *      For multiple field names, separate with commas. Direction defaults to ascending.
	 *      For descending, add -1 after the field name, e.g. 'firstName -1'
	 */
  , setSortOrder: function(fieldNamesAndDirections) {
	    if (typeof fieldNamesAndDirections != 'string') {
	        console.error('setSortOrder() parameter must be a string');
	        return;
	    }
	    var self = this;
	    self.$orderby = {};

		fieldNamesAndDirections = fieldNamesAndDirections.split(',');
		var field, direction;
		fieldNamesAndDirections.forEach(function(fieldAndDirection) {
			fieldAndDirection = fieldAndDirection.trim().split(' ');
			field = fieldAndDirection[0].trim();
			direction = fieldAndDirection[1] ? parseInt(fieldAndDirection[1]): 1;

			self.$orderby[field] = direction;
		});
	}
});